import { c as _c } from "react/compiler-runtime";
import { TdsNextLink } from '@/components/Link/TdsLink';
import { HOME_SLUG, METRICS_PATH, STATISTICS_PATH } from '@/constants';
import { type SearchPartial } from '@/features/search/api';
import { type Category } from '@/payload/payload.types';
import { type PaginatedDocs } from 'payload';
import React from 'react';
interface SearchResultsProps {
  searchResults: PaginatedDocs<SearchPartial>;
  title: string;
  noResultsText: string;
}
export const SearchResults: React.FC<SearchResultsProps> = t0 => {
  const $ = _c(16);
  const {
    searchResults,
    title,
    noResultsText
  } = t0;
  let t1;
  if ($[0] !== searchResults.totalDocs) {
    t1 = <span className="text-xl text-semantic-content-faint font-normal">{searchResults.totalDocs}</span>;
    $[0] = searchResults.totalDocs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== title) {
    t2 = <h2 className="text-2xl font-bold text-semantic-content-brand mb-4 hidden lg:block">{title}:{" "}{t1}</h2>;
    $[2] = t1;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== noResultsText || $[6] !== searchResults.docs.length) {
    t3 = searchResults.docs.length === 0 ? <p>{noResultsText}</p> : null;
    $[5] = noResultsText;
    $[6] = searchResults.docs.length;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== searchResults.docs) {
    t4 = searchResults.docs.map(_temp);
    $[8] = searchResults.docs;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <article className="flex flex-col space-y-3 text-semantic-content">{t3}{t4}</article>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <div>{t2}{t5}</div>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
const unique = (array: string[]) => {
  return [...new Set(array)];
};
const getCategoryNames = (categories: (number | Category)[] | null | undefined) => {
  if (categories?.length) {
    return categories.filter(category => typeof category !== 'number').map(category => {
      if (typeof category.parent === 'object' && category.parent?.name) {
        return category.parent.name;
      }
      return category.name;
    });
  }
  return [];
};
const getAllCategoryNames = (searchResult: SearchPartial) => {
  if (searchResult.type === 'page') {
    return [];
  }
  if (searchResult.categories?.length) {
    return unique(getCategoryNames(searchResult.categories));
  }
  if (searchResult.groups?.length) {
    return unique(searchResult.groups.filter(group => typeof group !== 'number').flatMap(group => {
      return getCategoryNames(group.categories);
    }));
  }
};
function getUrl(result: SearchPartial): string {
  switch (result.type) {
    case 'page':
      return result.slug === HOME_SLUG ? '/' : result.slug || '';
    case 'metric':
      return `${METRICS_PATH}/${result.doc?.value}`;
    case 'statistic':
      return `${STATISTICS_PATH}/${result.doc?.value}`;
    default:
      console.warn(`Unknown search result type: ${result.type}`);
      return '';
  }
}
function _temp(result) {
  const categoryNames = getAllCategoryNames(result);
  const pageCategoryName = typeof result.category === "object" ? result.category?.name : null;
  return <TdsNextLink key={result.id} href={getUrl(result)} variant="inline-neutral" className="p-2 leading-tight !no-underline hover:outline-none hover:!text-semantic-content-brand focus:!outline outline-semantic-focus-outer outline-2 -outline-offset-4 rounded-md focus:!shadow-none flex-col items-start">{categoryNames && categoryNames.length > 0 && <small className="tds-body-sm all-small-caps font-bold tracking-wider -mb-1">{categoryNames.join(", ")}</small>}{pageCategoryName && <small className="tds-body-sm all-small-caps font-bold tracking-wider -mb-1">{pageCategoryName}</small>}<span className="text-lg font-bold">{result.title}</span></TdsNextLink>;
}